import React, { Component } from 'react';
import { Card, CardImg, CardImgOverlay,
    CardTitle, CardBody, CardText, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Loading } from './LoadingComponent';

function RenderFischerteachesItem ({fischerteaches}) {
    return (
        <Card>
           <Link to={`/fischerteaches/${fischerteaches.id}`} >
            {<CardBody>
                <CardTitle>{fischerteaches.name}</CardTitle>
             </CardBody>}
           </Link>
        </Card>
    );
}

const Fischerteaches = (props) => {

    const fischerteaches = props.fischerteaches.map((fischerteach) => {
        return (
            <div className="col-12 col-md-5 m-1"  key={fischerteach.id}>
                <RenderFischerteachesItem fischerteaches={fischerteach} onClick={props.onClick}/>
            </div>
        );
    });

return (
    <div className="container">
        <div className="row">
            <Breadcrumb>
                <BreadcrumbItem><Link to="/home">Home</Link></BreadcrumbItem>
                <BreadcrumbItem active>Fischerteaches</BreadcrumbItem>
            </Breadcrumb>
            <div className="col-12">
                <p>Excerpts from the book 'Bobby Fischer Teaches Chess'. Return again for much more.</p>
                <hr />
            </div>
        </div>
        <div className="row">
            {fischerteaches}
        </div>
    </div>
);
}


export default Fischerteaches;
